import React, { useContext } from 'react';
import { Switch } from 'antd';
import { ThemeContext } from '../../context/ThemeContext';
import { ThemeSwitchWrapper } from './styled';
import { FiMoon, FiSun } from 'react-icons/fi';

const Theme = () => {
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);

  return (
    <ThemeSwitchWrapper isDark={isDarkMode}>
      <div className='d-flex align-items-center' >
        <FiSun style={{color:isDarkMode ? '#ffffff' : '#000000'}} size={16}/>
      </div>  
      <Switch
        checked={isDarkMode}
        onChange={toggleTheme}
        // checkedChildren="🌙"
        // unCheckedChildren="☀️"
        style={{ marginRight: '16px' }}
      />
      <div className='d-flex align-items-center' >
        <FiMoon   style={{color:isDarkMode ? '#ffffff' : '#000000'}} size={16}/>
      </div>
    </ThemeSwitchWrapper>
  );
};

export default Theme; 